import { Link } from "react-router-dom";

import Logo from "@/assets/images/logo/air_connect_logo_white.svg";
import Symbol from "@/assets/images/logo/air_connect_symbol_white.svg";
import { IconButton } from "@/components/atoms/IconButton";
import { tv } from "@/lib/tailwind-variants";

const headerLogoLinkVariants = tv({
  base: "hover:bg-transparent hover:opacity-75",
  variants: {
    collapsed: {
      false: "block h-auto w-auto",
    },
  },
  defaultVariants: {
    collapsed: false,
  },
});

export const HeaderLogoLink = ({ collapsed }: { collapsed: boolean }) => {
  return (
    <IconButton
      asChild
      variant="noBgPrimary"
      ariaLabel="AIR Connect"
      className={headerLogoLinkVariants({ collapsed })}
    >
      <Link to="/" className="overflow-hidden">
        <span className="pointer-events-none relative block h-4 w-[145px]">
          <img
            src={Logo}
            width={145}
            height={16}
            alt=""
            aria-hidden="true"
            className={`absolute inset-y-0 left-0 transition-opacity duration-200 ${
              collapsed ? "opacity-0" : "opacity-100"
            }`}
          />
          <img
            src={Symbol}
            width={20}
            height={20}
            alt=""
            aria-hidden="true"
            className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-200 ${
              collapsed ? "opacity-100" : "opacity-0"
            }`}
          />
        </span>
      </Link>
    </IconButton>
  );
};
